<template>
  <div id="topo">
    <div class="container">
      <div class="Personal">
        <img
          :src="imagem"
          alt="Gabriel oliveira: Desenvolvedor front end"
          class="bannerImg"
        />

        <h3>Gabriel de Oliveira</h3>
        <p>Desenvolvedor Web | Analista QA</p>
        <div class="icones">
          <a :href="github" target="_blank"
            ><ion-icon name="logo-github" size="large"></ion-icon
          ></a>
          <a :href="linkedin" target="_blank"
            ><ion-icon name="logo-linkedin" size="large"></ion-icon
          ></a>
          <a :href="whatsapp" target="_blank"
            ><ion-icon name="logo-whatsapp" size="large"></ion-icon
          ></a>
          <a :href="email" target="_blank"
            ><ion-icon name="mail-sharp" size="large"></ion-icon
          ></a>
        </div>
      </div>

      <div class="Content">
        <div class="FirstContent">
          <p>Olá, bem vindo(a)</p>
          <h5>Sou Gabriel, Analista QA e desenvolvedor web</h5>
          <h6 class="BannerText">
            Graduado em Análise e Desenvolvimento de Sistemas pela Fatec
            Guaratinguetá, sempre busco aprimorar minhas habilidades de acordo com o mercado atual
          </h6>
          <a :href="whatsapp" target="_blank" class="btnCV" download>
            Entre em contato
         
          </a>
        </div>

        <div class="SecondContent">
          <h3>Tecnologias</h3>
          <p>Algumas linguagens e tecnologias utilizadas</p>
          <br />

          <div>
            <VueSlickCarousel :arrows="false" :dots="false" v-bind="settings">
              <div v-for="item in Tecs" :key="item.id">
                <img
                  :src="item.img"
                  class="images"
                  alt="tecnologias utilizadas"
                />
                <!-- <p class="cardName">{{item.name}}</p> -->
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerVue",

  data() {
    return {
      imagem: "./images/imagem.png",
      contato: "https://api.whatsapp.com/send?phone=5512997068967",
      Tecs: [
        {
          id: 1,
          name: "Vue JS",
          img: "./images/tec/vue.png",
        },
        {
          id: 2,
          name: "React JS",
          img: "./images/tec/reactjs.png",
        },

        {
          id: 3,
          name: "Node Js",
          img: "./images/tec/node.png",
        },
        {
          id: 4,
          name: "Laravel",
          img: "./images/tec/laravel.png",
        },
        {
          id: 5,
          name: "Wordpress",
          img: "./images/tec/wordpress.png",
        },

        {
          id: 6,
          name: "Figma",
          img: "./images/tec/figma.png",
        },
        {
          id: 7,
          name: "photoshop",
          img: "./images/tec/photoshop.png",
        },
      ],

      CV: "./assets/GabrielOliveira.pdf",
      whatsapp: "https://api.whatsapp.com/send?phone=5512997068967",
      github: "https://github.com/Zokaaah",
      linkedin: "https://www.linkedin.com/in/gabriel-oliveira-silva-471b23194/",
      email: "mailto:gabriel.oliveira_012@hotmail.com",

      settings: {
        arrows: false,
        slidesToShow: 4,
        initialSlide: 0,
        dots: false,
        swipe: true,
        infinite: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnDotsHover: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.container {
  margin-top: 5%;
  display: flex;
  flex-direction: row;
  margin-bottom: 5%;
  justify-content: center;
}
.Content {
  width: 55%;
  padding: 3%;
}

.Content h5 {
  font-size: 25px !important;
}
.Firstcontent p {
  font-size: 10px !important;
}

.FirstContent {
  text-align: left !important;
  padding: 5% !important;
  height: 300px;
  margin-bottom: 5%;
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 1%;
  margin-top: 3%;
  transition: all 0.3s;
  -webkit-transition: width 1s;
  transition: width 1s;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);

  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
}
.BannerText {
  font-size: 20px !important;
  margin-bottom: 5%;
}

.btnCV {
  color: #fff !important;
  background-color: #4453e1;
  border-radius: 14px;
  padding: 2%;
  text-decoration: none;
  transition: all 0.3s;
  -webkit-transition: width 1s;
  transition: width 1s;

  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
  margin-top: 5% !important;
  width: 400px !important;
  font-size: 20px;
}
.btnCV:hover {
  background-color: #fff;
  color: #4453e1 !important;
  border: solid 1px #4453e1;
  transform: scale(1.1);
}
.SecondContent {
  height: 250px;
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 1%;
  margin-top: 3%;
  transition: all 0.3s;
  -webkit-transition: width 1s;
  transition: width 1s;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);

  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
  padding: 3%;

  align-content: center;
}

.images {
  height: 70px;
  width: 80px;
  margin: 0 auto;
}

.Personal {
  width: 35%;
  text-align: center;
  padding: 5%;
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 1%;
  margin-top: 3%;
  transition: all 0.3s;
  -webkit-transition: width 1s;
  transition: width 1s;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);

  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
  height: auto;
}
.Personal ion-icon {
  margin-right: 15px !important;
}
.icones a {
  color: #2c3e50;
}
.titulo {
  font-size: 46px;
  text-align: left;
  font-weight: bold;
}
p {
  font-size: 22px;
}
span {
  color: #4453e1;
}

.btnContato {
  color: #fff;
  background-color: #4453e1;
  border-radius: 7px;
  padding: 12px;
  font-size: 22px;
  width: 300px;
  border: solid 1px #4453e1;
  cursor: pointer;
  font-family: "Montserrat-VariableFont_wght" !important;

  transition: all 0.3s;
  -webkit-transition: width 1s;
  transition: width 1s;

  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
  float: left;
}
.btnContato:hover {
  background-color: #fff;
  color: #4453e1;
  border: solid 1px #4453e1;
  transform: scale(1.1);
}

.bannerImg {
  width: 80%;
  height: auto;
}

a {
  font-family: "Montserrat-VariableFont_wght" !important;
}

@font-face {
  font-family: Montserrat-VariableFont_wght;
  src: url("~@/assets/Montserrat-VariableFont_wght.ttf");
}

@media only screen and (max-width: 869px) {
  .titulo {
    width: 100%;
    font-size: 26px;
    text-align: center;
  }

  p {
    text-align: center;
  }

  .btnContato {
    float: none;
  }

  .container {
    margin-top: 5%;
    display: flex;
    flex-direction: column;
    margin-bottom: 5%;
    justify-content: center;
    width: 100% !important;
    overflow-x: hidden !important;
  }
  .Content {
    width: 100% !important;
    padding: 3%;
  }

  .Content h5 {
    font-size: 25px !important;
  }
  .content p {
    font-size: 16px !important;
  }

  .FirstContent {
    text-align: center !important;
    padding: 5% !important;
    height: auto;
    margin-bottom: 5%;
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 1%;
    margin-top: 3%;
    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
      0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
      0 16px 16px rgba(0, 0, 0, 0.12);

    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
    width: 100%;
  }

  .btnCV {
    color: #fff !important;
    background-color: #4453e1;
    border-radius: 14px;
    padding: 3%;
    text-decoration: none;
    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;

    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
    margin-top: 5% !important;
    width: 450px !important;
    font-size: 20px;
  }
  .btnCV:hover {
    background-color: #fff;
    color: #4453e1 !important;
    border: solid 1px #4453e1;
    transform: scale(1.1);
  }
  .SecondContent {
    height: 250px;
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 1%;
    margin-top: 3%;
    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
      0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
      0 16px 16px rgba(0, 0, 0, 0.12);

    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
    padding: 3%;

    align-content: center;
    width: 100%;
  }

  .images {
    height: 70px;
    width: 80px;
    margin: 0 auto;
  }

  .Personal {
    width: 100%;
    text-align: center;
    padding: 5%;
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 1%;
    margin-top: 3%;
    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
      0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
      0 16px 16px rgba(0, 0, 0, 0.12);

    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
    height: auto;
  }
  .Personal ion-icon {
    margin-right: 15px !important;
  }
  .titulo {
    font-size: 46px;
    text-align: left;
    font-weight: bold;
  }
  p {
    font-size: 22px;
  }
  span {
    color: #4453e1;
  }

  .btnContato {
    color: #fff;
    background-color: #4453e1;
    border-radius: 7px;
    padding: 12px;
    font-size: 22px;
    width: 300px;
    border: solid 1px #4453e1;
    cursor: pointer;
    font-family: "Montserrat-VariableFont_wght" !important;

    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;

    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
    float: left;
  }
  .btnContato:hover {
    background-color: #fff;
    color: #4453e1;
    border: solid 1px #4453e1;
    transform: scale(1.1);
  }

  .bannerImg {
    width: 80%;
    height: auto;
  }
}
</style>
